/**
 * Who owns the horizontal swipe right now.
 *
 * MeMo has two things a sideways drag could mean, and they cannot both be true
 * at the same moment:
 *
 *   - move to the next SECTION (Today → Search → Tasks → Settings), which is
 *     what App.jsx has always done;
 *   - move to the next DAY, which is what Jodi asked for: "in Day view, to go
 *     to the previous day or next day, I have to tap on the arrow. It would be
 *     a lot easier if I could just swipe the screen."
 *
 * She is right, and not only because it is less work: on a calendar, a sideways
 * drag means time. Every calendar app on both phones does it. The arrows stay
 * exactly where they are for anyone who prefers them, and the bottom bar is
 * still how you change section — a section is four taps away at most, whereas
 * "tomorrow" is somewhere you go dozens of times a day.
 *
 * So the day view CLAIMS the swipe while it is on screen, and App.jsx stands
 * down. Week, month and year do not claim it, so there the drag still moves
 * between sections as before.
 *
 * A claim is a single string, not a counter: if a screen forgets to release
 * it — a crash, a fast unmount — the next claim replaces it rather than
 * leaving the swipe dead for the rest of the session. A stuck gesture is the
 * kind of fault nobody reports, they just stop using it.
 */

let owner = null;

export function claimSwipe(name) { owner = name || null; }

export function releaseSwipe(name) { if (owner === name) owner = null; }

/** True when nobody else has taken it. */
export function swipeIsFree() { return owner === null; }
